import { withTranslation } from "react-i18next";

const Footer = ({ t }: any) => {
  return (
    <>
      <div
        style={{
          margin: "0 auto",
          width: "100%",
          textAlign: "center",
        }}
      >
        {/* TODO need logo */}
        {/* <img
          src={`/img/svg/todo-logo-large-01.svg`}
          alt="todo"
          width={navigator.maxTouchPoints > 0 ? "192px" : "384px"}
          height={navigator.maxTouchPoints > 0 ? "192px" : "384px"}
        /> */}
      </div>
    </>
  );
};

export default withTranslation()(Footer);
